<template>
  <div class="main">
    <h2>学习数据概览</h2>
    <br />
    <div>
      <span>我的学校：<a-tag color="blue">{{schoolName}}</a-tag></span>
      <br><br>
      <span>我的班级：</span>
      <a-tag v-for="(d,i) in departs" :key="i" :color="d.orgCategory==3?'blue':'pink'">
        {{d.departName}}
      </a-tag>
    </div>
    <a-divider></a-divider>
    <a-alert v-if="newCourse" message="您有课程即将开课" type="info" show-icon>
      <a-row slot="description">
        <a-col :span="18">
          <span
            >课程：{{ newCourse.courseName }}--{{ newCourse.unitName }}</span
          >
          <br />
          <span>开课时间: {{ newCourse.openTime }}</span>
        </a-col>
        <a-col :span="6">
          <a-button size="large" type="primary">去上课</a-button>
        </a-col>
      </a-row>
    </a-alert>
    <br />
    <a-row  v-if="report" justify="space-around" type="flex" :gutter="[40, 40]">
      <a-col :span="6">
        <div class="data-tag" style="">
          <h3>
            作业提交次数
            <a-tooltip placement="top">
              <template slot="title">
                <span>已经提交的作业数量</span>
              </template>
              <a-icon type="question-circle" style="color: gray" />
            </a-tooltip>
          </h3>
          <h2>{{ report.myAdditionWorkCount }}</h2>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="data-tag" style="">
          <h3>
            待完成作业数量

            <a-tooltip placement="top">
              <template slot="title">
                <span>待完成的作业的数量</span>
              </template>
              <a-icon type="question-circle" style="color: gray" />
            </a-tooltip>
          </h3>
          <h2>{{ report.todoAdditionWorkCount }}</h2>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="data-tag" style="">
          <h3>
            已完成课件数
            <a-tooltip placement="top">
              <template slot="title">
                <span>教师批改作业的份数</span>
              </template>
              <a-icon type="question-circle" style="color: gray" />
            </a-tooltip>
          </h3>
          <h2>{{report.courseMediaCount}}</h2>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="data-tag" style="">
          <h3>
            学习时长
            <a-tooltip placement="top">
              <template slot="title">
                <span>观看课程视频的时长</span>
              </template>
              <a-icon type="question-circle" style="color: gray" />
            </a-tooltip>
          </h3>
          <h2>{{report.videoStudyDuration}}</h2>
        </div>
      </a-col>
    </a-row>
    <br />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG,SYSTEM_INFO } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import { getNewCourse } from "@/api/course";
export default {
  name: "Index",
  data() {
    return {
      newCourse: null,
      report: null,
      departs: []
    };
  },
  created() {
    let systemInfo = Vue.ls.get(SYSTEM_INFO)
    this.schoolName = systemInfo&&systemInfo.schoolName ? systemInfo.schoolName : this.$store.state.user.info.school
    this.departs = this.$store.state.user.userDepart
    this.getNewCourse();
    this.getStudentReport();
  },
  methods: {
    getNewCourse() {
      getAction("/teaching/teachingCourse/getNewCourse", {
        dayRange: 3,
        limit: 1,
      }).then((res) => {
        if (res.success) {
          // this.courseSchedule = res.result;
          if (res.result.length > 0) {
            this.newCourse = res.result[0];
          }
        }
      });
    },
    getStudentReport() {
      getAction("/teaching/teachingDepartDayLog/studentReport").then((res) => {
        if (res.success) {
          this.report = res.result;
        } else {
          this.$message.info(res.message);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  .data-tag {
    padding: 15px;
    width: 100%;
    text-align: center;
    background-color: #f2fbf7;
    border-radius: 5px;
  }
}
</style>